"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCaseTypes = exports.getStates = exports.resetStore = exports.staticError = exports.setUser = exports.setCaseTypes = exports.setStates = void 0;
const lodash_1 = __importDefault(require("lodash"));
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const currentYear = (new Date()).getFullYear();
const getYears = (props = {
    start: currentYear,
    stop: (currentYear - 60),
    step: -1
}) => {
    const { start, stop, step } = props;
    return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));
};
const initialState = {
    states: [],
    caseTypes: [],
    user: {},
    yearsList: getYears().map(v => `${v}`),
    months: Array.from({ length: 12 }, (e, i) => new Date(null, i + 1, null)
        .toLocaleDateString("en", { month: "long" }))
};
const staticDataSlice = toolkit_1.createSlice({
    name: 'staticData',
    initialState: initialState,
    reducers: {
        setStates: (state, action) => {
            state.states = action.payload;
            return state;
        },
        setCaseTypes: (state, action) => {
            state.caseTypes = action.payload;
            return state;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        staticError: (state, action) => action.payload,
        resetState: () => {
            return lodash_1.default.cloneDeep(initialState);
        },
        resetStore: () => {
            // reset store logic is handled in the rootReducer.ts file
        }
    }
});
_a = staticDataSlice.actions, exports.setStates = _a.setStates, exports.setCaseTypes = _a.setCaseTypes, exports.setUser = _a.setUser, exports.staticError = _a.staticError, exports.resetStore = _a.resetStore;
const getStates = () => {
    return async (dispatch) => {
        try {
            const payload = await api_1.Static.statesOnly();
            return dispatch(exports.setStates(payload));
        }
        catch (e) {
            return dispatch(exports.staticError({ payload: e }));
        }
    };
};
exports.getStates = getStates;
const getCaseTypes = () => {
    return async (dispatch) => {
        try {
            const payload = await api_1.Static.caseTypes();
            return dispatch(exports.setCaseTypes(payload));
        }
        catch (e) {
            return dispatch(exports.staticError({ payload: e }));
        }
    };
};
exports.getCaseTypes = getCaseTypes;
/*export const getUser = (id: number) => {
  return async (dispatch: any) => {
    try {
      const payload = await Auth.getUserAllData(id, false);

      return dispatch(setUser(payload));
    } catch (e) {
      return dispatch(staticError({payload: e}))
    }
  }
}*/
exports.default = staticDataSlice.reducer;
